import ApiDOMError from "./ApiDOMError.mjs";
class UnsupportedOperationError extends ApiDOMError {}
export default UnsupportedOperationError;